import './dsFocus.js';

/**
 * Chip — a selectable filter pill (round chips, month chips, the mode switch).
 *
 * Not a skill export: gap-audit.md §2 names FilterChip as a gap in the design system,
 * so this one is built straight from tokens (brief iron rule 8). It sits on the PILL
 * ladder of iron rule 3, not the control ladder: two tiers only, `small` = 22
 * (--oc-pill-sm, nested chips) and `large` = 26 (--oc-pill-lg, top-level), radius 36.
 * The selected state uses the info hue per spec D4 — purple stays reserved for the
 * single primary CTA per view (PM iron rule 4).
 *
 * Focus ring: shared, via data-ds-focusable (spec S8).
 */
export function Chip ({ children, active = false, size = 'small', disabled = false, className, ...rest }) {
  const s = size === 'large' ? 'large' : 'small';

  return (
    <button
      type="button"
      disabled={disabled}
      aria-pressed={active}
      data-ds-focusable
      className={['oc-chip', `oc-chip--${s}`, active && 'oc-chip--active', className]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </button>
  );
}
